// extracted by mini-css-extract-plugin
export default {"cls1":"DbOpslGWL_5cdtZTSn9v","cls2":"kDhwANjIEUHDeyNIBALX DbOpslGWL_5cdtZTSn9v"};